import React, { useState } from "react";

const ImageGallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // Sample images - replace with your actual image URLs
  const images = [
    {
      id: 1,
      thumbnail: "assets/images/achievements/1.jpeg",
      full: "assets/images/achievements/1.jpeg",
      title: "Image 1"
    },
    {
      id: 2,
      thumbnail: "assets/images/achievements/2.jpeg",
      full: "assets/images/achievements/2.jpeg",
      title: "Image 2"
    },
    {
      id: 3,
      thumbnail: "assets/images/achievements/3.jpeg",
      full: "assets/images/achievements/3.jpeg",
      title: "Image 3"
    },
    {
      id: 4,
      thumbnail: "assets/images/achievements/4.jpeg",
      full: "assets/images/achievements/4.jpeg",
      title: "Image 4"
    },
    {
      id: 5,
      thumbnail: "assets/images/achievements/5.jpeg",
      full: "assets/images/achievements/5.jpeg",
      title: "Image 5"
    },
    {
      id: 6,
      thumbnail: "assets/images/achievements/7.jpeg",
      full: "assets/images/achievements/7.jpeg",
      title: "Image 6"
    }
  ];

  const openImage = (index) => {
    setCurrentIndex(index);
    setSelectedImage(images[index]);
  };

  const closeImage = () => {
    setSelectedImage(null);
  };

  const goToPrevious = () => {
    const newIndex = currentIndex > 0 ? currentIndex - 1 : images.length - 1;
    setCurrentIndex(newIndex);
    setSelectedImage(images[newIndex]);
  };

  const goToNext = () => {
    const newIndex = currentIndex < images.length - 1 ? currentIndex + 1 : 0;
    setCurrentIndex(newIndex);
    setSelectedImage(images[newIndex]);
  };

  const handleKeyPress = (e) => {
    if (!selectedImage) return;
    if (e.key === "ArrowLeft") goToPrevious();
    if (e.key === "ArrowRight") goToNext();
    if (e.key === "Escape") closeImage();
  };

  React.useEffect(() => {
    window.addEventListener("keydown", handleKeyPress);
    return () => window.removeEventListener("keydown", handleKeyPress);
  }, [selectedImage, currentIndex]);

  return (
    <>
      <style>{`
        /* Gallery Grid Styles */
        .gallery-container {
          padding: 20px 0;
        }
        
        .gallery-item {
          margin-bottom: 20px;
          cursor: pointer;
          transition: transform 0.3s ease;
        }
        
        .gallery-item:hover {
          transform: scale(1.05);
        }
        
        .gallery-item img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          border-radius: 4px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        }
        
        .gallery-item-title {
          text-align: center;
          margin-top: 8px;
          font-size: 14px;
          color: #333;
        }

        /* Lightbox Styles */
        .lightbox-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.95);
          z-index: 9999;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .lightbox-content {
          position: relative;
          width: 90%;
          height: 90%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .lightbox-image {
          max-width: 100%;
          max-height: 100%;
          object-fit: contain;
          border-radius: 4px;
        }
        
        .lightbox-back-btn {
          position: absolute;
          top: 20px;
          left: 20px;
          background-color: rgba(255, 255, 255, 0.9);
          border: none;
          padding: 10px 20px;
          border-radius: 4px;
          cursor: pointer;
          font-size: 16px;
          z-index: 10000;
          transition: background-color 0.3s ease;
        }
        
        .lightbox-back-btn:hover {
          background-color: #fff;
        }
        
        .lightbox-nav-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          background-color: rgba(255, 255, 255, 0.9);
          border: none;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          cursor: pointer;
          font-size: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background-color 0.3s ease;
          z-index: 10000;
        }
        
        .lightbox-nav-btn:hover {
          background-color: #fff;
        }
        
        .lightbox-nav-btn.prev {
          left: 20px;
        }
        
        .lightbox-nav-btn.next {
          right: 20px;
        }
        
        .lightbox-counter {
          position: absolute;
          bottom: 20px;
          left: 50%;
          transform: translateX(-50%);
          background-color: rgba(255, 255, 255, 0.9);
          padding: 8px 16px;
          border-radius: 20px;
          font-size: 14px;
          color: #333;
          z-index: 10000;
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .lightbox-back-btn {
            top: 10px;
            left: 10px;
            padding: 8px 16px;
            font-size: 14px;
          }
          
          .lightbox-nav-btn {
            width: 40px;
            height: 40px;
            font-size: 20px;
          }
          
          .lightbox-nav-btn.prev {
            left: 10px;
          }
          
          .lightbox-nav-btn.next {
            right: 10px;
          }
          
          .lightbox-counter {
            bottom: 10px;
            font-size: 12px;
            padding: 6px 12px;
          }
        }
      `}</style>

      <div className="container gallery-container">
        <div className="row">
          <div className="col-xs-12">
            <div className="row" style={{ marginBottom: '20px' }}>
              <div className="col-xs-12">
                <button 
                  className="btn btn-default"
                  onClick={() => window.history.back()}
                  style={{ marginBottom: '10px' }}
                >
                  Back
                </button>
              </div>
            </div>
            <h1 className="text-center">Image Gallery</h1>
            <hr />
          </div>
        </div>

        <div className="row">
          {images.map((image, index) => (
            <div key={image.id} className="col-xs-12 col-sm-6 col-md-4">
              <div className="gallery-item" onClick={() => openImage(index)}>
                <img src={image.thumbnail} alt={image.title} />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Lightbox */}
      {selectedImage && (
        <div className="lightbox-overlay" onClick={closeImage}>
          <button className="lightbox-back-btn" onClick={closeImage}>
            Back
          </button>

          <button className="lightbox-nav-btn prev" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
            <strong>&lt;</strong>
          </button>

          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedImage.full}
              alt={selectedImage.title}
              className="lightbox-image"
            />
          </div>

          <button className="lightbox-nav-btn next" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
            <strong>&gt;</strong>
          </button>

          <div className="lightbox-counter">
            {currentIndex + 1} / {images.length}
          </div>
        </div>
      )}
    </>
  );
};

export default ImageGallery;